// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"3654b5a11f3af86d39fc","92":"87899ce2b654e8644fcf","777":"236ad23c262c9246220c"}[chunkId] + ".js";
};